import React, { memo } from "react";

import { OFFICE_STATUS_OPTIONS } from "services/api/offices/consts";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Naziv": kartica poslovnice sa šifrom i statusom, pa popis poslovnica tvrtke. */
const OfficeInfoScene: React.FC<OfficeSceneProps> = ({ formValues, name }) => {
  const status = OFFICE_STATUS_OPTIONS.find((option) => option.value === formValues.status)?.text ?? "Aktivna";

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-11 h-11 rounded-md bg-blue-50 flex-shrink-0">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-5h6v5M9 10h.01M15 10h.01" />
              </svg>
            </span>
            <div className="min-w-0">
              <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Poslovnica</div>
              <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
            </div>
          </div>

          <div className="mt-4 space-y-2">
            {[
              { label: "Šifra", value: formValues.code || OFFICE_INTRO_SAMPLE.code },
              { label: "Interna oznaka", value: formValues.internalMark || OFFICE_INTRO_SAMPLE.internalMark },
              { label: "Status", value: status },
            ].map((row) => (
              <div key={row.label} className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <span className="text-slate-500">{row.label}</span>
                <span className="font-semibold text-slate-800 truncate">{row.value}</span>
              </div>
            ))}
          </div>
          <p className="mt-3 text-[0.65rem] leading-relaxed text-slate-400 line-clamp-2">
            {formValues.description || OFFICE_INTRO_SAMPLE.description}
          </p>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Poslovnice tvrtke</div>
          <div className="mt-3 space-y-2 text-[0.65rem]">
            {OFFICE_INTRO_SAMPLE.otherOffices.map((office) => (
              <div key={office} className="flex items-center gap-2 text-slate-400">
                <span className="w-2 h-2 rounded-full bg-slate-300" />
                <span className="truncate">{office}</span>
              </div>
            ))}
            <div className="flex items-center gap-2 font-semibold text-slate-700">
              <span className="w-2 h-2 rounded-full bg-blue-600" />
              <span className="truncate">{name}</span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Odmah dostupna u sustavu"
          subtitle="Za vozila, korisnike i troškove"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficeInfoScene);
